module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_3016.2604ac46.png";